import calls from '@/backend/api-calls'

const state = () => ({
  processingMethods: [],
  processingTypes: [],
  selected: [],
  allSelected: false,
  loading: false,
  typesLoading: false,
  pagination: {
    page: 1,
    pages: 1
  },
  filters: {
  }
})

// getters
const getters = {
  ids: state => {
    return state.processingMethods.map(d => d.id);
  }
}

// actions
const actions = {
  getProcessingMethods: ({commit}, parameters) => {
    commit("setLoading", true);
    return new Promise((resolve, reject) => {
      calls.processingMethods.get(parameters)
        .then(resp => {
          commit("setProcessingMethods", resp.data);
          commit("setLoading", false);
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  addProcessingMethod: ({commit}, data) => {
    return new Promise((resolve, reject) => {
      calls.processingMethods.post(data)
        .then(resp => {
          commit("insertProcessingMethod", resp.data);
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Processing method successfully added'
          }, { root: true });
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  updateProcessingMethod: ({commit}, { processingMethodId, data }) => {
    return new Promise((resolve, reject) => {
      calls.processingMethod.put(processingMethodId, data)
        .then(resp => {
          commit("insertUpdatedProcessingMethod", resp.data);
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Processing method successfully updated'
          }, { root: true });
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  deleteProcessingMethod: ({commit}, processingMethodId) => {
    return new Promise((resolve, reject) => {
      calls.processingMethod.delete(processingMethodId)
        .then(resp => {
          commit("removeProcessingMethod", processingMethodId);
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Processing method successfully deleted'
          }, { root: true });
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  toggleAllSelected: ({commit, getters}, value) => {
    if (value) {
      commit("selectAll", getters.ids);
    } else {
      commit("deselectAll");
    }
  },
  getProcessingTypes: ({commit}, parameters) => {
    commit("setTypesLoading", true);
    return new Promise((resolve, reject) => {
      calls.processingMethodTypes.get(parameters)
        .then(resp => {
          commit("setProcessingTypes", resp.data);
          commit("setLoading", false);
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  addProcessingType: ({commit}, data) => {
    return new Promise((resolve, reject) => {
      calls.processingMethodTypes.post(data)
        .then(resp => {
          commit("insertProcessingType", resp.data);
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  updateProcessingType: ({commit}, { processingTypeId, data }) => {
    return new Promise((resolve, reject) => {
      calls.processingMethodType.put(processingTypeId, data)
        .then(resp => {
          commit("insertUpdatedProcessingType", resp.data);
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  deleteProcessingType: ({commit}, processingTypeId) => {
    return new Promise((resolve, reject) => {
      calls.processingMethodType.delete(processingTypeId)
        .then(resp => {
          commit("removeProcessingType", processingTypeId);
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Processing method type successfully deleted'
          }, { root: true });
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  }
}

// mutations
const mutations = {
  setLoading(state, status) {
    state.loading = status;
  },
  setProcessingMethods (state, data) {
    state.processingMethods = data.results;
    state.pagination = data.pagination;
  },
  insertProcessingMethod (state, data) {
    state.processingMethods.push(data);
  },
  insertUpdatedProcessingMethod (state, data) {
    state.processingMethods.forEach((process, i) => {
      if (process.id == data.id) {
        state.processingMethods.splice(i, 1, data);
      }
    })
  },
  removeProcessingMethod (state, id) {
    state.processingMethods.forEach((process, i) => {
      if (process.id == id) {
        state.processingMethods.splice(i, 1);
        let ind = state.selected.indexOf(id);
        if (ind != -1) {
          state.selected.splice(ind);
        }
      }
    })
  },
  changePage(state, page) {
    state.pagination.page = page;
  },
  selectAll(state, ids) {
    state.allSelected = true;
    ids.forEach(id => {
      if (state.selected.indexOf(id) == -1) {
        state.selected.push(id);
      }
    })
  },
  deselectAll(state) {
    state.allSelected = false;
    state.selected.splice(0, state.selected.length)
  },
  toggleSelected(state, id) {
    const index = state.selected.indexOf(id);

    if (index == -1) {
      state.selected.push(id);
    } else {
      state.selected.splice(index, 1);
      if (state.selected.length == 0) {
        state.allSelected = false;
      }
    }
  },
  // Procesing Method Types
  setTypesLoading(state, status) {
    state.typesLoading = status;
  },
  setProcessingTypes (state, data) {
    state.processingTypes = data.results;
  },
  insertProcessingType (state, data) {
    state.processingTypes.push(data);
  },
  insertUpdatedProcessingType (state, data) {
    state.processingTypes.forEach((type, i) => {
      if (type.id == data.id) {
        state.processingTypes.splice(i, 1, data);
      }
    })
  },
  removeProcessingType (state, id) {
    state.processingTypes.forEach((type, i) => {
      if (type.id == id) {
        state.processingTypes.splice(i, 1);
        let ind = state.selected.indexOf(id);
        if (ind != -1) {
          state.selected.splice(ind);
        }
      }
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}